import { forwardRef } from "react";
import UIButton from "hardcover-ui/components/Button";
import classNames from "lib/classNames";

const DrawerButton = forwardRef((props: any, ref) => {
  const { onclick, isLoading, isActive, children, className, ...rest } = props;
  return (
    <UIButton
      size="none"
      ref={ref}
      onClick={onclick}
      isLoading={isLoading}
      className={classNames(
        className,
        "text-lg md:text-base px-4 md:px-2 py-2 lg:py-1 w-full font-semibold ",
        isActive
          ? "text-accent hover:bg-background"
          : "text-foreground group hover:bg-background hover:text-accent transition-all"
      )}
      {...rest}
    >
      {children}
    </UIButton>
  );
});

export default DrawerButton;
